import DocumentCEFormController from './document.ce.form.controller';

export default {
    template: require('./document.ce.form.html'),
    controller: DocumentCEFormController
};
